// extracted by mini-css-extract-plugin
export default {"allContainer":"Presentation_allContainer__WUbXj"};